module.exports = __webpack_public_path__ + "img/logo.ce9b9d51.svg";